export default "<div class=\"information-bar\" [class.editable]=\"editable\">\n  <ng-content></ng-content>\n</div>\n"